<ng-template cellTemplate let-dataItem="dataItem">
    <div class="canvas" [ngClass]="{'checkered': !!(dataItem | property: field)}">
        <div class="color-display"
             (click)="$event['ignoreClickOutside'] = true"
             *ngIf="(dataItem | property: field) !== '#00000000'"
             [style.background-color]="dataItem | property: field">
            <span class="color-display-text"
                  [style.color]="dataItem | property: field | colorText">{{dataItem | property: field}}</span>
        </div>
    </div>
</ng-template>
<ng-template editTemplate
             let-dataItem="dataItem"
             let-columnIndex="columnIndex"
             let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex" [editControl]="editControl">
    </wbo-edit-grid-cell-activator>
    <div class="color-edit">
        <fui-color-control #editControl [attr.id]="elementId"
                           [formControl]="formGroup.get(column.field)"
                           [control]="formGroup.get(column.field)"
                           [allowAlpha]="allowAlpha"
                           [readOnly]="cellDisabled(formGroup, dataItem)"
                           (focussed$)="columnFocusHandler(columnIndex)"
                           [placeholder]="getPlaceholder(dataItem)">
        </fui-color-control>
    </div>
</ng-template>
